module.exports = __webpack_public_path__ + "img/xnr8.0b8ad65e.jpg";